import React, { useContext } from 'react';
import {
  Title5,
  Icon,
  TextRegular,
  TextSmall,
  ListItemWithImage,
  Image,
  Carousel,
  UtilsBlock,
} from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './SellValueChecker.module.scss';
import EnvironmentContext from '../../../contexts/EnvironmentContext';

const CHECK_KEYS = ['check1', 'check2'] as const;
const EXAMPLE_KEYS = [
  {
    key: 'volkswagen',
    name: 'Volkswagen Golf',
    year: 2022,
    mileage: '50.000 km',
    priceRange: '€18.500 - €20.000',
  },
  {
    key: 'volvo',
    name: 'Volvo XC40',
    year: 2022,
    mileage: '90.000 km',
    priceRange: '€27.500 - €32.000',
  },
  {
    key: 'ford',
    name: 'Ford Focus',
    year: 2021,
    mileage: '45.000 km',
    priceRange: '€17.500 - €19.000',
  },
] as const;

const SellValueChecker = () => {
  const { t } = useI18nContext();
  const {
    links: { imageSources },
  } = useContext(EnvironmentContext);

  return (
    <div className={Classes.root}>
      <div className={Classes.left}>
        <div>
          <UtilsBlock
            as="h3"
            mb="xxs"
            textStyle={['title-4', null, 'title-2']}
            className={`Section-title ${Classes.title}`}
          >
            <div className="Title-highlight">{t('sell.page.value_checker.titleHighlight')}</div>
            <div>{t('sell.page.value_checker.titleAfter')}</div>
          </UtilsBlock>
          <UtilsBlock color="text-secondary">{t('sell.page.value_checker.subtitle')}</UtilsBlock>
        </div>
        <ul className={Classes.checklist}>
          {CHECK_KEYS.map((key) => (
            <ListItemWithImage key={key} image={<Icon name="checkmark" color="text-brand-primary" />}>
              <UtilsBlock textStyle={['body-regular-strong', null, 'body-large-strong']} color="text-primary">
                {t(`sell.page.value_checker.${key}.label`)}
              </UtilsBlock>
              <UtilsBlock color="text-secondary">{t(`sell.page.value_checker.${key}.body`)}</UtilsBlock>
            </ListItemWithImage>
          ))}
        </ul>
        <UtilsBlock color="text-secondary">{t('sell.page.value_checker.footer')}</UtilsBlock>
      </div>
      <div className={Classes.right}>
        <TextSmall color="text-secondary" className={Classes.exampleDisclaimer}>
          {t('sell.page.value_checker.example.label')}
        </TextSmall>
        <Carousel title="" className="exampleCarousel">
          {EXAMPLE_KEYS.map(({ key, name, year, mileage, priceRange }) => (
            <article key={key} className={Classes.exampleCard}>
              <Image
                className={Classes.exampleImage}
                src={imageSources[key]}
                alt="image"
                fetchPriority="auto"
                // @ts-expect-error -- DS issue
                aspectRatio=""
              />
              <div className={Classes.exampleContentContainer}>
                <div className={Classes.exampleContent}>
                  <Title5 as="div">{name}</Title5>
                  <TextRegular color="text-secondary">{`${year} · ${mileage}`}</TextRegular>
                </div>
                <div className={Classes.exampleContent}>
                  <TextSmall color="text-secondary">{t('sell.page.value_checker.priceRange')}</TextSmall>
                  <Title5 as="div">{priceRange}</Title5>
                </div>
              </div>
            </article>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default SellValueChecker;
